"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compProps', 'skin', 'language'], function (_a) {
    var compProps = _a.compProps, skin = _a.skin, language = _a.language;
    var isSocialLoginFacebookEnabled = compProps.isSocialLoginFacebookEnabled, isSocialLoginGoogleEnabled = compProps.isSocialLoginGoogleEnabled, mode = compProps.mode, isSmallIcons = compProps.isSmallIcons;
    return {
        skin: skin,
        language: language,
        isSocialLoginGoogleEnabled: isSocialLoginGoogleEnabled,
        isSocialLoginFacebookEnabled: isSocialLoginFacebookEnabled,
        mode: mode,
        isSmallIcons: isSmallIcons,
    };
});
exports.css = withCompInfo_1.withCompInfo([], function () {
    return {};
});
//# sourceMappingURL=SocialAuth.js.map